import request from '@/common/request'

export interface PoolStatus {
  nome: string
  url: string
  saudavel: boolean
  erroConexao: string
  conexoesAtivas: number
  conexoesOciosas: number
  conexoesTotais: number
  aguardandoConexao: number
  maxConexoes: number
  minOcioso: number
}

export interface DatasourceStatus {
  consultadoEm: string
  escrita: PoolStatus
  leitura: PoolStatus
}

export const findStatus = (): Promise<DatasourceStatus> =>
	request.get('/api/monitor/datasources')
